import { createElement } from 'react';
import { DatePicker as OriginalDatePicker } from 'antd';
const RangePicker = function RangePicker({ ...otherProps }) {
    const _otherProps = otherProps || {};
    return (createElement(OriginalDatePicker.RangePicker, { ..._otherProps }));
};
export default RangePicker;
